import { IdentifierCasing } from "@/apollo/types";
import { identifierCasingLabel } from "@/features/data-warehouse-schemas";

export type DestinationSettings = Record<string, unknown>;

type SettingsSchema = {
  properties?: Record<string, { default?: unknown }>;
};

export function destinationCasing(destination: {
  settings: DestinationSettings;
}): IdentifierCasing | null {
  return destination.settings.uppercaseIdentifiers === true
    ? IdentifierCasing.Uppercase
    : null;
}

export function hasSettings(schema: SettingsSchema) {
  return Object.keys(schema.properties ?? {}).length > 0;
}

export function settingsDefaults(schema: SettingsSchema): DestinationSettings {
  return Object.fromEntries(
    Object.entries(schema.properties ?? {})
      .filter(([, property]) => property.default !== undefined)
      .map(([key, property]) => [key, property.default]),
  );
}

/** A short, readable line per setting, e.g. ["ANALYTICS", "Upper case"]. */
export function describeSettings(settings: DestinationSettings): string[] {
  return Object.entries(settings)
    .filter(
      ([, value]) =>
        value !== null &&
        value !== undefined &&
        value !== "" &&
        value !== false,
    )
    .map(([key, value]) => {
      if (key === "uppercaseIdentifiers") {
        return identifierCasingLabel(IdentifierCasing.Uppercase);
      }
      return value === true ? key : String(value);
    });
}

export const usedBy = (syncCount: number) =>
  `Used by ${syncCount} ${syncCount === 1 ? "sync" : "syncs"}`;
